import { type RefObject, useEffect } from "react";

interface UseDismissOptions {
  enabled: boolean;
  containerRef: RefObject<HTMLElement | null>;
  onDismiss: () => void;
  closeOnEscape?: boolean;
}

// `mousedown` (no `click`) evita race con el toggle button del trigger:
// si listenamos `click`, el handler global corre DESPUÉS del onClick interno
// y vuelve a cerrar el menú que el trigger acaba de abrir.
export function useDismiss({
  enabled,
  containerRef,
  onDismiss,
  closeOnEscape = true,
}: UseDismissOptions): void {
  useEffect(() => {
    if (!enabled) return;

    const handlePointer = (e: MouseEvent) => {
      const node = containerRef.current;
      if (!node) return;
      if (!node.contains(e.target as Node)) onDismiss();
    };
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onDismiss();
    };

    document.addEventListener("mousedown", handlePointer);
    if (closeOnEscape) document.addEventListener("keydown", handleKey);

    return () => {
      document.removeEventListener("mousedown", handlePointer);
      if (closeOnEscape) document.removeEventListener("keydown", handleKey);
    };
  }, [enabled, containerRef, onDismiss, closeOnEscape]);
}
